export default "__VITE_ASSET__CZe1cVnL__"